import { render, staticRenderFns } from "./PopupTextShare.vue?vue&type=template&id=2a40ad30&scoped=true"
import script from "./PopupTextShare.vue?vue&type=script&lang=js"
export * from "./PopupTextShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a40ad30",
  null
  
)

export default component.exports